import { Observable } from 'rxjs';

export abstract class InitialiserDependency {
    public abstract ready$: () => Observable<unknown>;
}
